/*
 * <personalization-fields> — Etsy-style custom option fields on the product page.
 *
 * Store KHONG phai Shopify Plus => khong dung Cart Transform de cong gia. Thay
 * vao do, khi Add to cart ta them variant "phi" tuong ung tu product an
 * `personalization-fee` (moi muc add-on = 1 variant, add qty = qty san pham).
 *
 * Nhiem vu:
 *  1. Dem ky tu textarea; hien "Personalization: +$X" tam tinh.
 *  2. Validate field required truoc khi cho Add to cart.
 *  3. Bo (disable) field optional trong => khong tao property rong.
 *  4. Sau khi mon chinh vao gio, them cac line phi tuong ung roi render lai gio.
 */
if (!customElements.get('personalization-fields')) {
  customElements.define(
    'personalization-fields',
    class PersonalizationFields extends HTMLElement {
      connectedCallback() {
        this.currency = this.dataset.currency || 'USD';
        this.form = this.closest('form');
        // Input phi an — nam trong form (khong theo modal ra body) nen luon submit.
        this.addonInput = this.querySelector('.personalization__addon-input');

        // Map { gia_cents(string) -> variantId }
        try {
          this.feeMap = JSON.parse(this.dataset.feeMap || '{}');
        } catch (e) {
          this.feeMap = {};
        }

        // Chuyen modal ra <body> (this.scope = noi chua cac field). Phai chay
        // TRUOC khi query field/error/addon-line vi chung nam trong modal.
        this.setupModal();

        this.addonLine = this.scope.querySelector('.personalization__addon-line');
        this.addonDisplay = this.scope.querySelector('.personalization__addon-display');
        this.errorBox = this.scope.querySelector('.personalization__error');

        this.onChange = this.recalculate.bind(this);
        this.scope.addEventListener('input', this.onChange);
        this.scope.addEventListener('change', this.onChange);

        if (this.form) {
          // Capture chay TRUOC listener submit cua <product-form>: validate +
          // prune + ghi lai cac phi can them.
          this._submitHandler = this.onFormSubmit.bind(this);
          this.form.addEventListener('submit', this._submitHandler, true);
        }

        // Sau khi mon chinh vao gio thanh cong -> them line phi.
        this._pendingFees = null;
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this._unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
            if (evt && evt.source === 'product-form' && this._pendingFees) {
              this.appendFees();
            }
          });
        }

        this.setupCounters();
        this.setupDropdowns();
        this.recalculate();
        this.setupPaymentGuard();
        this.updateTriggerStatus();
      }

      /*
       * "Buy it now" / nut vi (Shop Pay, Google Pay…) cua Shopify KHONG qua su kien
       * submit cua form -> bo qua validate o onFormSubmit. Con field bat buoc trong thi
       * phu 1 lop trong suot len khung nut thanh toan: bam vao -> mo popup + canh bao.
       * Lop phu (thay vi bat click) vi nut vi nam trong iframe, JS trang khong nghe duoc.
       */
      setupPaymentGuard() {
        if (!this.form || !this.scope.querySelector('.personalization__input[required]')) return;
        const container = this.form.querySelector('.shopify-payment-button');
        if (!container) return;

        const guard = document.createElement('button');
        guard.type = 'button';
        guard.className = 'personalization__pay-guard';
        guard.setAttribute('aria-label', 'Complete the required personalization before checkout');
        guard.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const invalid = this.findFirstInvalidRequired();
          if (!invalid) {
            this.updatePaymentGuard();
            return;
          }
          this.openModal();
          this.showError('Please fill in all required personalization fields before checking out.');
          setTimeout(() => invalid.focus(), 40);
        });

        container.classList.add('personalization__pay-guarded');
        container.appendChild(guard);
        this.payContainer = container;
        this.payGuard = guard;

        // Shopify ve nut thanh toan bat dong bo (co the thay noi dung khung) -> gan lai lop phu.
        this._payObserver = new MutationObserver(() => {
          if (!container.contains(guard)) container.appendChild(guard);
          this.updatePaymentGuard();
        });
        this._payObserver.observe(container, { childList: true });
        this.scope.addEventListener('input', () => this.updatePaymentGuard());
        this.scope.addEventListener('change', () => this.updatePaymentGuard());
      }

      updatePaymentGuard() {
        if (!this.payGuard) return;
        const blocked = Boolean(this.findFirstInvalidRequired());
        this.payGuard.hidden = !blocked;
        // Chan ca ban phim (Tab + Enter) vao nut thanh toan phia duoi lop phu.
        Array.from(this.payContainer.children).forEach((child) => {
          if (child !== this.payGuard) child.inert = blocked;
        });
      }

      /* ---- Dropdown tuy bien (dong bo bundle): nut + menu tu style ---- */
      setupDropdowns() {
        const dds = this.scope.querySelectorAll('[data-pers-dd]');
        if (!dds.length) return;

        dds.forEach((dd) => {
          const btn = dd.querySelector('[data-pers-dd-btn]');
          const label = dd.querySelector('[data-pers-dd-label]');
          const menu = dd.querySelector('[data-pers-dd-menu]');
          const hidden = dd.querySelector('.personalization__dd-value');
          if (!btn || !menu || !hidden) return;

          const closeMenu = () => {
            menu.hidden = true;
            dd.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          };

          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            // Dong cac dropdown khac dang mo.
            this.scope.querySelectorAll('[data-pers-dd].is-open').forEach((other) => {
              if (other !== dd) {
                other.classList.remove('is-open');
                const m = other.querySelector('[data-pers-dd-menu]');
                if (m) m.hidden = true;
                const b = other.querySelector('[data-pers-dd-btn]');
                if (b) b.setAttribute('aria-expanded', 'false');
              }
            });
            const willOpen = menu.hidden;
            menu.hidden = !willOpen;
            dd.classList.toggle('is-open', willOpen);
            btn.setAttribute('aria-expanded', String(willOpen));
          });

          menu.querySelectorAll('.personalization__dd-opt').forEach((opt) => {
            opt.addEventListener('click', (e) => {
              e.stopPropagation();
              const val = opt.dataset.value || '';
              hidden.value = val;
              hidden.dataset.price = opt.dataset.price || '0';
              label.textContent = opt.textContent.trim();
              btn.classList.remove('is-placeholder');
              menu.querySelectorAll('.personalization__dd-opt.is-selected').forEach((x) => x.classList.remove('is-selected'));
              opt.classList.add('is-selected');
              closeMenu();
              // Bao cho recalculate + updateTriggerStatus.
              hidden.dispatchEvent(new Event('change', { bubbles: true }));
            });
          });
        });

        // Bam ra ngoai -> dong moi menu dang mo.
        if (!this._ddOutside) {
          this._ddOutside = () => {
            this.scope.querySelectorAll('[data-pers-dd].is-open').forEach((dd) => {
              dd.classList.remove('is-open');
              const m = dd.querySelector('[data-pers-dd-menu]');
              if (m) m.hidden = true;
              const b = dd.querySelector('[data-pers-dd-btn]');
              if (b) b.setAttribute('aria-expanded', 'false');
            });
          };
          document.addEventListener('click', this._ddOutside);
        }
      }

      disconnectedCallback() {
        if (this.form && this._submitHandler) {
          this.form.removeEventListener('submit', this._submitHandler, true);
        }
        if (this._unsubscribe) this._unsubscribe();
        if (this._payObserver) this._payObserver.disconnect();
        if (this._keyHandler) document.removeEventListener('keydown', this._keyHandler);
        if (this._ddOutside) document.removeEventListener('click', this._ddOutside);
        // Don modal da chuyen ra body de tranh ro ri khi element bi go.
        if (this.modal && this.modal.parentNode) this.modal.parentNode.removeChild(this.modal);
      }

      /* ---- Popup: nut "Custom" -> hien field trong modal (o giua man hinh) ---- */
      setupModal() {
        this.modal = this.querySelector('[data-pers-modal]');
        this.trigger = this.querySelector('[data-pers-open]');
        this.statusEl = this.querySelector('[data-pers-status]'); // nam trong nut trigger (o form)
        // Noi chua cac field: modal neu co, nguoc lai chinh element (fallback).
        this.scope = this.modal || this;

        // Nut mo popup nam trong form -> query tu this.
        this.querySelectorAll('[data-pers-open]').forEach((btn) => {
          btn.addEventListener('click', () => this.openModal());
        });

        if (this.modal) {
          // Chuyen modal ra thang <body>: position:fixed phu ca man hinh, popup
          // luon canh giua, khong bi "nhot" trong cot info (transform/sticky).
          // Input van submit nho thuoc tinh form="..." tren tung field.
          document.body.appendChild(this.modal);

          this.modal.querySelectorAll('[data-pers-close], [data-pers-done]').forEach((btn) => {
            btn.addEventListener('click', () => this.closeModal());
          });
          // Cap nhat trang thai nut trigger moi khi doi gia tri trong modal.
          this.modal.addEventListener('input', () => this.updateTriggerStatus());
          this.modal.addEventListener('change', () => this.updateTriggerStatus());
        }

        this._keyHandler = (e) => {
          if (e.key === 'Escape' && this.modal && !this.modal.hidden) this.closeModal();
        };
        document.addEventListener('keydown', this._keyHandler);
      }

      openModal() {
        if (!this.modal) return;
        this.modal.hidden = false;
        document.body.style.overflow = 'hidden';
        const firstInput = this.modal.querySelector('.personalization__input');
        if (firstInput) setTimeout(() => firstInput.focus(), 30);
      }

      closeModal() {
        if (!this.modal) return;
        this.modal.hidden = true;
        document.body.style.overflow = '';
        this.updateTriggerStatus();
      }

      /** Doi trang thai vien nut trigger (giu text = tieu de, dong bo bundle). */
      updateTriggerStatus() {
        this.updatePaymentGuard();
        if (!this.trigger) return;
        let filled = 0;
        let missingRequired = 0;
        this.scope.querySelectorAll('.personalization__field').forEach((field) => {
          const input = field.querySelector('.personalization__input');
          if (!input) return;
          let empty;
          if (input.type === 'file') empty = !(input.files && input.files.length > 0);
          else empty = !String(input.value).trim();
          if (!empty) filled += 1;
          if (empty && input.required) missingRequired += 1;
        });

        this.trigger.classList.toggle('personalization__trigger--filled', filled > 0 && missingRequired === 0);
        this.trigger.classList.toggle('personalization__trigger--partial', missingRequired > 0 && filled > 0);
      }

      setupCounters() {
        this.scope.querySelectorAll('.personalization__text').forEach((el) => {
          const field = el.closest('.personalization__field');
          const counter = field && field.querySelector('.personalization__count');
          if (!counter) return;
          const update = () => {
            counter.textContent = String(el.value.length);
          };
          el.addEventListener('input', update);
          update();
        });
      }

      /** Add-on (cents) dang ap dung cho 1 field, tuy loai va gia tri hien tai. */
      fieldAddon(field) {
        const base = parseInt(field.dataset.addon, 10) || 0;
        const type = field.dataset.type;
        const input = field.querySelector('.personalization__input');
        if (!input) return 0;

        if (type === 'dropdown') {
          if (!input.value) return 0;
          // Dropdown tuy bien: gia option luu tren data-price cua input an.
          const optPrice = parseInt(input.dataset.price, 10) || 0;
          return optPrice > 0 ? optPrice : base;
        }
        if (type === 'file') {
          return input.files && input.files.length > 0 ? base : 0;
        }
        return input.value.trim() ? base : 0;
      }

      recalculate() {
        let total = 0;
        this.scope.querySelectorAll('.personalization__field').forEach((field) => {
          total += this.fieldAddon(field);
        });

        if (this.addonInput) this.addonInput.value = String(total);

        if (this.addonLine && this.addonDisplay) {
          if (total > 0) {
            this.addonDisplay.textContent = '+' + this.formatMoney(total);
            this.addonLine.hidden = false;
          } else {
            this.addonLine.hidden = true;
          }
        }
      }

      /** Tra ve { variantId: soLuong } cac phi can them cho 1 mon (per unit). */
      collectFees() {
        const fees = {};
        this.scope.querySelectorAll('.personalization__field').forEach((field) => {
          const cents = this.fieldAddon(field);
          if (cents <= 0) return;
          const entry = this.feeMap[String(cents)];
          const variantId = entry && typeof entry === 'object' ? (entry.ok === false ? null : entry.id) : entry;
          if (!variantId) return; // khong co variant phi khop -> bo qua
          fees[variantId] = (fees[variantId] || 0) + 1;
        });
        return fees;
      }

      /** Field dang co gia (>0) nhung khong tim thay variant phi dung -> tra ve field do. */
      findUnpricedField() {
        let bad = null;
        this.scope.querySelectorAll('.personalization__field').forEach((field) => {
          if (bad) return;
          const cents = this.fieldAddon(field);
          if (cents <= 0) return;
          const entry = this.feeMap[String(cents)];
          const variantId = entry && typeof entry === 'object' ? (entry.ok === false ? null : entry.id) : entry;
          if (!variantId) bad = field;
        });
        return bad;
      }

      onFormSubmit(evt) {
        this.hideError();

        // 1) Validate required
        const invalid = this.findFirstInvalidRequired();
        if (invalid) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          // Popup dang dong -> mo len de khach thay field can dien.
          if (this.modal && this.modal.hidden) this.openModal();
          this.showError('Please fill in all required personalization fields.');
          setTimeout(() => invalid.focus(), 40);
          this._pendingFees = null;
          return;
        }

        // 1b) Field co gia nhung khong co variant phi khop (thieu SKU / het hang):
        //     khong cho them gio, tranh cho khach ca nhan hoa mien phi.
        const unpriced = this.findUnpricedField();
        if (unpriced) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          if (this.modal && this.modal.hidden) this.openModal();
          this.showError('This personalization option is unavailable right now. Please remove it or try again later.');
          this._pendingFees = null;
          return;
        }

        // 2) Chuan bi phi (nhan voi qty mon chinh)
        const qty = parseInt(this.form.querySelector('[name="quantity"]')?.value, 10) || 1;
        const perUnit = this.collectFees();
        const fees = Object.keys(perUnit).length
          ? Object.fromEntries(Object.entries(perUnit).map(([id, n]) => [id, n * qty]))
          : null;
        this._pendingFees = fees;

        // 3) Bo field optional trong (sau khi da tinh phi)
        this.pruneEmptyOptional();
      }

      findFirstInvalidRequired() {
        let first = null;
        this.scope.querySelectorAll('.personalization__input').forEach((input) => {
          if (first || !input.required) return;
          let empty;
          if (input.type === 'file') empty = !(input.files && input.files.length > 0);
          else empty = !String(input.value).trim();
          if (empty) first = input;
        });
        return first;
      }

      pruneEmptyOptional() {
        const disabled = [];
        this.scope.querySelectorAll('.personalization__input').forEach((input) => {
          if (input.required) return;
          let empty;
          if (input.type === 'file') empty = !(input.files && input.files.length > 0);
          else empty = !String(input.value).trim();
          if (empty) {
            input.disabled = true;
            disabled.push(input);
          }
        });
        if (disabled.length) {
          setTimeout(() => disabled.forEach((el) => (el.disabled = false)), 0);
        }
      }

      /** Them cac line phi vao gio roi render lai cart drawer/notification. */
      appendFees() {
        const fees = this._pendingFees;
        this._pendingFees = null;
        if (!fees || !Object.keys(fees).length) return;

        const items = Object.entries(fees).map(([id, quantity]) => ({
          id: Number(id),
          quantity,
          properties: { _personalization_fee: 'true' },
        }));

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((response) => {
            if (cart && typeof cart.renderContents === 'function' && response.sections) {
              cart.renderContents(response);
            }
          })
          .catch((e) => console.error('personalization fee add failed', e));
      }

      showError(msg) {
        if (!this.errorBox) return;
        this.errorBox.textContent = msg;
        this.errorBox.hidden = false;
      }

      hideError() {
        if (this.errorBox) this.errorBox.hidden = true;
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.currency,
          }).format(cents / 100);
        } catch (e) {
          return '$' + (cents / 100).toFixed(2);
        }
      }
    }
  );
}
